import { render, staticRenderFns } from "./legal_public.vue?vue&type=template&id=37724ae0&scoped=true&"
import script from "./legal_public.vue?vue&type=script&lang=js&"
export * from "./legal_public.vue?vue&type=script&lang=js&"
import style0 from "./legal_public.vue?vue&type=style&index=0&id=37724ae0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37724ae0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContent,VRow})
